// toolSlice.js
import { createSlice } from "@reduxjs/toolkit";
import { creatTool, getAllTools } from "../actions/job";

const initialState = {
  tools: [],
  loading: false,
  error: null,
};

const toolSlice = createSlice({
  name: "tools",
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      // Reducer for creating a tool
      .addCase(creatTool.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(creatTool.fulfilled, (state, action) => {
        console.log("action", action);

        state.loading = false;
        state.tools.push(action.payload);
      })
      .addCase(creatTool.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      })
      // Reducer for getting all tools
      .addCase(getAllTools.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(getAllTools.fulfilled, (state, action) => {
        state.loading = false;
        state.tools = action.payload;
      })
      .addCase(getAllTools.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      });
  },
});

export default toolSlice.reducer;
